import axios, { handleRequest, setAuthorizationToken } from './api-connecting'

export const UserListAPI = () => handleRequest(axios.get('/admin/user',).then(data => data))
export const UserDetailsAPI = (params) => handleRequest(axios.get(`/admin/user/${params}`,).then(data => data))
export const UserCreateAPI = (params) => handleRequest(axios.post(`/admin/user/create`, params).then(data => data))
export const UserEditAPI = (id, params) => handleRequest(axios.patch(`/admin/user/${id}`, params).then(data => data))